import React from "react";
import {component_tool,utils_tool} from "@/tool";
import {WizTableForm} from '@/containers/common';
import moment from "moment";
import AuthVideo from "./authVideo";
import BatchInput from "./batchInput";
let { $$ } = utils_tool;
const organizationConfig = WizTableForm.Config.organization(this, {apiParams: {state: 1}})
const positionConfig = WizTableForm.Config.position(this, {apiParams: {state: 1}})
const personInfoConfig = WizTableForm.Config.user(this, { apiParams: { state: 1,positionIdList: ["110"] },path:'personManage/getTeachelist' })
let {WizModal} = component_tool;
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY.MM.DD') : '';
}
const formatterTime = (val) => {
  return val ? moment(val).format('HH:mm:ss') : '';
}
//配置项
const componentName = "classStudentManagement";
let ref;
let ref_;
const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "姓名",
    name: "fullName",
    dataIndex: "fullName",
    tableItem: {
      width: 120,
    },
    formItem: {}
  },
  {
    title: "姓名",
    name: "fullNameSearch",
    dataIndex: "fullNameSearch",
    searchItem: {},
  },
  {
    title: "账号",
    name: "userName",
    dataIndex: "userName",
    tableItem: {
      width: 120,
    },
    formItem: {}
  },
  {
    title: "账号",
    name: "userNameSearch",
    dataIndex: "userNameSearch",
    searchItem: {},
  },
  {
    title: '手机号',
    name: 'mobile',
    tableItem: {
      width: 120,
    }
  },
  {
    title: "组织名称",
    name: "orgIds",
    searchItem: {
      diy: WizTableForm,
      ...organizationConfig,
    }
  },
  {
    title: "岗位",
    name: "positionIds",
    searchItem: {
      diy: WizTableForm,
      ...positionConfig,
    }
  },

  {
    title: "组织名称",
    name: "orgName",
    tableItem: {
      width: 180,
    }
  },
  {
    title: "组织编码",
    name: "orgCode",
    tableItem: {
      width: 100,
    },
  },
  {
    title: "岗位",
    name: "positionName",
    tableItem: {
      width: 100,
    }
  },
  {
    title: "任职状态",
    name: "jobState",
    dict: [
      {code: 0, codeName: '离职'},
      {code: 1, codeName: '在职'},
    ],
    tableItem: {
      width: 100,
    },
  },
  {
    title: "是否请假",
    name: "leaveState",
    dict: [
      {code: 0, codeName: "否"},
      {code: 1, codeName: "是"}
    ],
    tableItem: {
      width: 100,
    },
    searchItem: {
      type: 'select'
    }
  },
  {
    title: "认证日期",
    name: "authDate",
    tableItem: {
      width: 100,
      render: (text, record) => {
        return formatterDate(text)
      }
    },
  },
  {
    title: "认证时间",
    name: "startDate",
    tableItem: {
      width: 140,
      render: (text, record) => {
        return (record.startDate ? formatterTime(record.startDate) + ' ~ ' : '') + (record.endDate ? formatterTime(record.endDate) : '')
      }
    },
  },
  {
    title: '分配状态',
    name: 'isConfig',
    tableItem: {
      width: 100,
    },
    searchItem: {
      type: 'select'
    },
    dict: [
      {code: 0, codeName: "未分配"},
      {code: 1, codeName: "已分配"}
    ]
  },
  {
    title: "讲师",
    name: "lectureFullName",
    tableItem: {
      width: 80,
    },
  },
  {
    title: "认证状态",
    name: "authState",
    searchItem: {
      type: 'select'
    },
    // dict: [
    //   {code: 0, codeName: '未开始'},
    //   {code: 1, codeName: '已开始'},
    //   {code: 2, codeName: '认证中'},
    //   {code: 3, codeName: '未参考'},
    //   {code: 4, codeName: '已完成'},
    //   {code: 5, codeName: '可回看'},
    // ],
    dict: [
      { code: 0, codeName: '未开始' },
      { code: 2, codeName: '认证中' },
      { code: 3, codeName: '未参考' },
      { code: 4, codeName: '已完成' },
      { code: 6, codeName: '已作废' }
    ],
    tableItem: {
      width: 100,
    },
  },
  {
    title: "总得分",
    name: "score",
    tableItem: {
      width: 80,
      render: (text, record) => {
        return text && text < 0 ? '' : text
      }
    },
  },
  {
    title: "通过状态",
    name: "pass",
    dict: [
      {code: 0, codeName: '未通过'},
      {code: 1, codeName: '已通过'},
    ],
    tableItem: {
      width: 100,
    },
    searchItem: {
      type: 'select'
    }
  },
  {
    title: "发布状态",
    name: "publishState",
    searchItem: {
      type: 'select'
    },
    dict: [
      { code: 0, codeName: '待更新' },
      { code: 1, codeName: '可发布' },
      { code: 2, codeName: '已发布' },
      { code: 3, codeName: '未参考' }
    ],
    tableItem: {
      width: 80,
    },
  },
  {
    title: "视频工具",
    name: "videoTool",
    dict: [
      { code: 1, codeName: '中目' },
      { code: 2, codeName: '慧课堂' },
    ],
    tableItem: {
    },
  },
  // {
  //   title: "讲师",
  //   name: "lectureIds",
  //   searchItem: {
  //     type: 'diy',
  //     diy: WizTableForm,
  //     ...personInfoConfig,
  //     onSubmit:(obj)=>{
  //       return obj.value
  //     }
  //   },
  // },
];

const templateConfig = (date) => {
  const {onSelect, classInfoId, _btnLookUserFun, _this, classAideId, entityId,classAideEntityInfo} = date;
  let _onSelect = (key, rows) => {
    onSelect && onSelect(key, rows);
    ref_ && ref_.getSelectRows && ref_.getSelectRows(rows)
  };
  let initRows = () => {
    return _this.state.selectedClassRemoteAuthRows
  };
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns,
        btnAccessCheck:false,
        searchBarProps: {
          buttonSort: ['batchSet','resultsGrades','importGrades', 'export'],
          buttons: [
            {
              key: "batchSet",
              custom: true,
              needSelect: true,
              params: {children: "批量设置", type: "info"},
              customOnClick: {
                key: "modal",
                params: {
                  modalKey: new Date().getTime(),
                  modalParams: {
                    title: "批量设置",
                    diy: (e) => {
                      e.record = Object.assign({}, e.record)
                      return (
                        <BatchInput
                          {...e}
                          key={'Input' + e.record.id}
                          initRows={initRows}
                          ref={r => {
                            ref_ = r && r.getWrappedInstance();
                          }}
                          timeStamp={new Date().getTime()}
                          classInfoId={classInfoId}
                          classAideId={classAideId}
                          entityId={entityId}
                          classAideEntityInfo={classAideEntityInfo}
                        />
                      )
                    },
                    onOk: () => {
                      ref_._ok();
                    },
                    onCancel: () => {
                      ref_._doInitParams()
                    },
                    width: 600
                  }
                }
              },
              recordChangeParams: ({record, rows}) => {
                let disabled = 0;
                if (rows && rows instanceof Array && rows.length > 0) {
                  let videoTools = [];
                  rows.forEach(item => {
                    let {isConfig,videoTool} = item;
                    if (isConfig != null && isConfig === 1) {
                      disabled = 1;
                    }
                    videoTools.push(videoTool)
                  })
                  if(Array.from(new Set(videoTools)).length>1){
                    disabled = 1;
                  }
                } else {
                  disabled = 1;
                }
                return {disabled: disabled}
              }
            },
            {
              key: 'importGrades',
              custom: true,
              params: { icon: 'import', children: '导入成绩', type: 'primary'},
              customOnClick: {
                key: 'jumpPage',
                params: {
                  key: 'push',
                  pathname: '/face/classList/classAideDetail/classStudentRemoteAuthList/studentRemoteAuthScoreImport',
                  record: {
                    ...classAideEntityInfo,
                  }
                }
              }
            },
            {
              key: 'resultsGrades',
              custom: true,
              needSelect: true,
              params: { children: '发布成绩'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: 'publishState',
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  if (!rows) return;
                  if ($$.isArray(rows) && !rows.length) return;
                  const content = `您确定要发布这${
                    $$.isArray(rows) ? rows.length : ""
                    }条成绩？`;
                  let ids = [];
                  let flag = false;
                  rows.forEach(e => {
                    if (e['studentRemoteAuthDetailId']) {
                      ids.push(e['studentRemoteAuthDetailId']);
                    }
                    if (e['publishState']!=1){
                      flag = true;
                    }
                  });
                  if(flag){
                    wizNotice.warn("只可选择可发布状态的学员进行发布成绩,请确认后重试!")
                    return;
                  }
                  WizModal.confirm({
                    title: '注意', content,
                    onOk: () => {
                      callback && callback({
                        idList: ids,
                        publishState: 2
                      })
                    },
                    onCancel() {
                    }
                  });
                  return null
                }
              }
            },
            {
              key: 'export',
              custom: true,
              params: {icon: 'export', children: '导出', type: 'primary'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "exportClassStudentRemoteAuth",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return {...filters}
                }
              }
            }
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          isScroll: true,
          loading: false,
          onSelect: _onSelect,
          bordered: false,
          paging: false,
          selectType: "checkbox",
        },
        commonOperate: {
          update: false
        },
        rowOperateSort: ['videoPlayback', 'authenticationSet','disable'],
        rowOperateView: [
          {
            key: "videoPlayback",
            custom: true,
            params: {children: "录像回放"},
            customOnClick: {
              key: "modal",
              params: {
                modalKey: "playbackModal",
                modalParams: {
                  title: "录像回放",
                  diy: (e) => {
                    e.record = Object.assign({}, e.record);
                    return (
                      <AuthVideo
                        key={'authVideo-' + e.record.id}
                        {...e}
                        type={0}
                        ref={r => {
                          ref_ = r && r.getWrappedInstance();
                        }}
                      />
                    )
                  },
                  footer: null,

                  width: 700
                }
              },
              formatParams: (rows, record, filter) => {
                return {...record};
              }
            },
            recordChangeParams: (record, rows) => {
              let result = {disabled: true};
              if (record.record && record.record.publishState > 0 && record.record.publishState != 3) {
                result.disabled = false
              }
              // if (record.record && record.record.videoTool && record.record.videoTool == 2) {
              //   result.disabled = true
              // }
              return result
            },
          },
          {
            key: "authenticationSet",
            custom: true,
            params: {children: '认证设置'},
            customOnClick: {
              key: "modal",
              params: {
                modalKey: new Date().getTime(),
                modalParams: {
                  title: "认证设置",
                  diy: (e) => {
                    e.record = Object.assign({}, e.record)
                    return (
                      <BatchInput
                        {...e}
                        key={'BatchInput' + e.record.id + new Date().getTime()}
                        initRows={initRows}
                        ref={r => {
                          ref_ = r && r.getWrappedInstance();
                        }}
                        timeStamp={new Date().getTime()}
                        classInfoId={classInfoId}
                        classAideId={classAideId}
                        entityId={entityId}
                        classAideEntityInfo={classAideEntityInfo}
                        alone={true}
                      />
                    )
                  },
                  onOk: () => {
                    ref_._ok();
                  },
                  onCancel: () => {
                    ref_._doInitParams()
                  },
                  width: 600
                }
              },
              formatParams: (rows, record, filter) => {
                return {...record};
              },
            },
            recordChangeParams: (record, rows) => {
              let result = {disabled: true};
              if (record.record && record.record.publishState === 0 && record.record.authState === 0) {
                result.disabled = false
              }
              //关闭的环节,禁用
              if(classAideEntityInfo.status==1){
                result.disabled = true
              }
              return result
            },
          },
          {
            key: "disable",
            custom: true,
            params: { children: "作废"},
            customOnClick: {
              key: "action",
              params: {
                apiKey: "updateAuthState",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                const content = `您确定要作废该认证吗？`;
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      authState: 6,
                      id: record['studentRemoteAuthDetailId']
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            },
            recordChangeParams: (record, rows) => {
              let result = {disabled: true};
              if (record.record && record.record.isConfig === 1 && record.record.authState === 0) {
                result.disabled = false
              }
              //关闭的环节,禁用
              if(classAideEntityInfo.status==1){
                result.disabled = true
              }
              return result
            },
          },
        ]
      }
    }
  }
};


let reduxTemplateCofig = args => {
  const {classInfoId, entityId, classAideId} = args;
  const apis = {
    list: {
      path: `${componentName}/remoteAuthByPage`,
      payload: {
        key: `${componentName}@remoteAuthByPage`,
        apiParams: {classInfoId: classInfoId, entityId: entityId, classAideId: classAideId}
      }
    },
    exportClassStudentRemoteAuth: {
      path: `${componentName}/remoteAuthByList`,
      payload: {
        key: `${componentName}@remoteAuthByList`,
        apiParams: {classInfoId: classInfoId, entityId: entityId, classAideId: classAideId}
      }
    },
    publishState: {
      path: `${'studentRemoteAuthDetail'}/publishStateRe`,
      payload: {
        key: `${'studentRemoteAuthDetail'}@publishState`,
        apiParams: {}
      }
    },
    updateAuthState: {
      path: "studentRemoteAuthDetail/updateAuthState",
      payload: {
        key: 'studentRemoteAuthDetail@updateAuthState',
        apiParams: {}
      }
    }
  };

  return {
    apis,
    componentName,
    initApiKeys: ["list"],
    keepInitApiParams: true,
    needLoading: false,
    ...args
  };
};

export {reduxTemplateCofig, templateConfig};
